import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useGame } from '../context/GameContext';
import { ZoomButton } from './shared/StyledComponents';

const MIN_ZOOM = 0.25;
const MAX_ZOOM = 2;
const ZOOM_STEP = 0.25;

const ZoomControls = () => {
  const theme = useTheme();
  const { zoom, setZoom: onZoomChange } = useGame();
  // Round to nearest 25% step
  const roundToStep = (value, roundDirection = 'up') => {
    if (roundDirection === 'up') {
      return Math.ceil(value / ZOOM_STEP) * ZOOM_STEP;
    } else {
      return Math.floor(value / ZOOM_STEP) * ZOOM_STEP;
    }
  };

  const handleZoomIn = () => {
    // Round current zoom up to nearest step
    const nextZoom = roundToStep(zoom, 'up');
    // If already at a step boundary, add one more step
    if (Math.abs(nextZoom - zoom) < 0.001) {
      onZoomChange(Math.min(MAX_ZOOM, nextZoom + ZOOM_STEP));
    } else {
      onZoomChange(Math.min(MAX_ZOOM, nextZoom));
    }
  };

  const handleZoomOut = () => {
    // Round current zoom down to nearest step
    const nextZoom = roundToStep(zoom, 'down');
    // If already at a step boundary, subtract one more step
    if (Math.abs(nextZoom - zoom) < 0.001) {
      onZoomChange(Math.max(MIN_ZOOM, nextZoom - ZOOM_STEP));
    } else {
      onZoomChange(Math.max(MIN_ZOOM, nextZoom));
    }
  };

  const handleResetZoom = () => {
    onZoomChange(1);
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: '80px',
        right: '20px',
        display: 'flex',
        opacity: 0.6,
        flexDirection: 'column',
        gap: '4px',
        zIndex: 1000,
        padding: '8px',
      }}
    >
      {/* Zoom In Button */}
      <Tooltip title="Zoom In" placement="left">
        <ZoomButton
          component="button"
          onClick={handleZoomIn}
          disabled={zoom >= MAX_ZOOM}
          zoom={zoom}
          theme={theme}
        >
          +
        </ZoomButton>
      </Tooltip>

      {/* Zoom Level Display */}
      <Box
        onClick={handleResetZoom}
        sx={{
          width: '36px',
          height: '28px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: '11px',
          fontWeight: 'bold',
          cursor: 'pointer',
          borderRadius: '4px',
          backgroundColor: 'rgba(255,255,255,0.1)',
          '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.2)',
          },
        }}
        title="Reset Zoom (click)"
      >
        {Math.round(zoom * 100)}%
      </Box>

      {/* Zoom Out Button */}
      <Tooltip title="Zoom Out" placement="left">
        <ZoomButton
          component="button"
          onClick={handleZoomOut}
          disabled={zoom <= MIN_ZOOM}
          zoom={zoom}
          theme={theme}
        >
          −
        </ZoomButton>
      </Tooltip>
    </Box>
  );
};

export default ZoomControls;

